export default "__VITE_ASSET__DiShE40G__";